export const normalizeSearchTerms = (searchValue?: string): string[] =>
  searchValue?.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean) ?? [];